import useSeason, { Season } from '@/hooks/useSeason';
import { HexColor, getDarkestColor, getLightestColor } from '@/lib/color';

type SeasonPalette = {
	primary: HexColor;
	secondary: HexColor;
	accent: HexColor;
	accentCompat: HexColor;
	accentOrCompatLightest?: HexColor;
	accentOrCompatDarkest?: HexColor;
	overlay: HexColor;
};

export const seasonPalettes: Record<Season, SeasonPalette> = {
	winter: {
		primary: '#08494D',
		secondary: '#1F7376',
		accent: '#5F1433',
		accentCompat: '#FFFFFF',
		overlay: '#DCEDF4',
	},
	spring: {
		primary: '#104523',
		secondary: '#448866',
		accent: '#E15E7C',
		accentCompat: '#FFFFFF',
		overlay: '#EAF8E2',
	},
	summer: {
		primary: '#10433C',
		secondary: '#2E7271',
		accent: '#D5246D',
		accentCompat: '#FFFFFF',
		overlay: '#EDF6F4',
	},
	fall: {
		primary: '#213F2E',
		secondary: '#4D8062',
		accent: '#F8C632',
		accentCompat: '#213F2E',
		overlay: '#F2EDD9',
	},
};

export const setSeasonPalette = (season: Season, element?: HTMLElement) => {
	// Get base palette
	const palette = seasonPalettes[season];

	// Add additional parsed accent colors
	palette.accentOrCompatLightest = getLightestColor(
		palette.accent,
		palette.accentCompat
	);
	palette.accentOrCompatDarkest = getDarkestColor(
		palette.accent,
		palette.accentCompat
	);

	// Apply palette to CSS variables
	Object.entries(palette).forEach(([key, value]) => {
		(element ?? document.documentElement).style.setProperty(
			`--color-${key}`,
			value
		);
	});
};

export const SeasonProvider = ({ children }: { children: React.ReactNode }) => {
	const season = useSeason();
	setSeasonPalette(season);
	return children;
};
